import { Grid, Typography, Box } from "@mui/material";

import inputControls from "../../../static/images/distant_bass_suite/utilities-input.png";
import widthRoomControls from "../../../static/images/distant_bass_suite/utilities-width-room.png";
import maximizerControls from "../../../static/images/distant_bass_suite/utilities-maximizer.png";

const UTILITY_GROUPS = [
  {
    name: "Gate and Bass Sim",
    image: inputControls,
    width: 346,
    height: 210,
    controls: [
      { name: "Gate", description: "Tighten your sound with the built-in gate." },
      { name: "Bass Sim", description: "Turn your guitar DI into a convincing bass DI. No actual bass guitar needed." },
    ],
  },
  {
    name: "Width and Room",
    image: widthRoomControls,
    width: 334,
    height: 168,
    controls: [
      { name: "Width", description: "Add some extra space to the upper harmonics of your bass sound." },
      { name: "Room", description: "Perfect for headphone users, Room adds subtle ambience to your sound for easy listening." },
    ],
  },
  {
    name: "Maximizer",
    image: maximizerControls,
    width: 360,
    height: 217,
    controls: [
      { name: "Maximizer", description: "This built-in limiter/maximizer lets you boost the loudness of your bass tone while keeping it stable and controlled." },
    ],
  },
];

const PluginUtilities = () => {
  return (
    <Box
      component="section"
      aria-labelledby="bass-distant-utilities-title"
      sx={{ px: { xs: 3, md: 5 }, py: { xs: 5, md: 7 }, background: "radial-gradient(circle, #eee 0%, #aaa 100%)", color: "#000" }}
    >
      <Typography id="bass-distant-utilities-title" component="h2" variant="h3" sx={{ textAlign: "center", mb: 5 }}>
        Utilities
      </Typography>
      <Box sx={{ maxWidth: 1200, mx: "auto" }}>
        <Grid container spacing={{ xs: 5, md: 4 }} justifyContent="center">
          {UTILITY_GROUPS.map((group) => (
            <Grid key={group.name} component="article" aria-label={group.name} item xs={12} md={4}>
              <Box sx={{ maxWidth: 360, mx: "auto" }}>
                <Box sx={{ height: { xs: "auto", md: 220 }, display: "flex", alignItems: "center", justifyContent: "center", mb: 3 }}>
                  <img
                    src={group.image}
                    alt={`BassSuite - Distant ${group.name} controls`}
                    width={group.width}
                    height={group.height}
                    loading="lazy"
                    decoding="async"
                    style={{ display: "block", maxWidth: "100%", height: "auto", borderRadius: "10px" }}
                  />
                </Box>
                {group.controls.map((control) => (
                  <Typography key={control.name} component="p" variant="h6" sx={{ textAlign: "left", mb: 2, "&:last-child": { mb: 0 } }}>
                    <b>{control.name}:</b> {control.description}
                  </Typography>
                ))}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default PluginUtilities;
